import Cookies from "js-cookie"

class CookieService {
  setCookie(name: string, value: string): void {
    Cookies.set(name, value, { secure: true, sameSite: "lax" })
  }

  getCookie(name: string): string | undefined {
    return Cookies.get(name)
  }

  removeCookie(name: string): void {
    Cookies.remove(name)
  }
}

export default new CookieService()
